import { Trans } from '@lingui/react/macro';

const BuyDialogHeader = ({ isFreeTee, onClose }) => (
  <div className="text-lg md:text-3xl md:py-5 bg-black relative font-bold w-full flex items-center justify-center">
    {isFreeTee ? (
      <h1
        id="buy-dialog__title"
        className="font-bold text-qw-red uppercase text-center "
      >
        <Trans>
          Wow! You get a free random tee! Pick your gender/size below
        </Trans>
      </h1>
    ) : (
      <h1
        id="buy-dialog__title"
        className="font-bold text-white uppercase leading-6"
      >
        <Trans>What would you like?</Trans>
      </h1>
    )}
    <button
      type="button"
      onClick={onClose}
      className="h-4 w-4 md:h-7 md:w-7 flex justify-center items-center pb-1 top-1 right-1 absolute bg-white"
    >
      x
    </button>
  </div>
);

export default BuyDialogHeader;
